var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.857 2.5H3.14C2.511 2.5 2 3.018 2 3.654v13.692c0 .636.51 1.154 1.14 1.154h13.717A1.15 1.15 0 0 0 18 17.346V3.654A1.15 1.15 0 0 0 16.857 2.5zM6.836 16.214H4.464V8.58H6.84v7.635h-.003zM5.65 7.536a1.376 1.376 0 0 1 0-2.75c.757 0 1.375.618 1.375 1.375 0 .76-.614 1.375-1.375 1.375zm10.075 8.678h-2.371V12.5c0-.886-.018-2.025-1.233-2.025-1.235 0-1.425.964-1.425 1.96v3.78H8.325V8.578H10.6V9.62h.032c.318-.6 1.093-1.232 2.247-1.232 2.4 0 2.846 1.582 2.846 3.64v4.185z",
    fill: "currentColor"
  })));
};
export default SvgLinkedIn;